/**
 * Global Privacy Control (GPC) — the one shared JS-expression STRING for "this
 * visitor's browser is signaling an opt-out", reused by every inline
 * analytics/ads snippet (Meta Pixel host guard, LinkedIn Insight Tag loader,
 * GA4 consent mode default) so they can't drift onto different checks.
 *
 * A string, not a function, for the same reason `META_PIXEL_HOST_GUARD` is:
 * these are inline `<script>` template literals with no import, so the check
 * has to be spliced in as source text. `navigator` always exists where these
 * snippets actually run (a browser), but the `typeof` guard keeps the
 * expression safe to eval anywhere (e.g. the test harness's `new Function`).
 */
export const GPC_ACTIVE =
  "(typeof navigator!=='undefined'&&navigator.globalPrivacyControl===true)" as const;
